/* eslint-disable no-prototype-builtins */
import ClientOnboardPage from 'app/pages/school/ClientOnboard/ClientOnboardPage'
import clsx from 'clsx'
import {getActiveSession, hasPermission, isAdmin} from 'common/HelperFunctions'
import {Select} from 'common/components/Fields'
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {getBranches} from 'setup/redux/Actions/General/getBranch'

import {ILayout, useLayout} from '../../core'

const Header: FC = () => {
  const {config} = useLayout()
  const dispatch = useDispatch()
  const intl = useIntl()

  const [branches, setBranches] = useState<any[]>([])
  const [loadingBranches, setLoadingBranches] = useState(false)

  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings
  ) as any

  const selectedBranch: any = localStorage.getItem('branch') ? localStorage.getItem('branch') : ''
  const [branch, setBranch] = useState(selectedBranch)

  const activeSession = getActiveSession()

  const loadBranches = () => {
    setLoadingBranches(true)

    const onSuccess = (res: any) => {
      const allBranches = res.result

      const permittedBranches = [{id: '', name: intl.formatMessage({id: 'GENERAL.ALL_BRANCHES'})}]

      for (let i = 0; i < allBranches.length; i++) {
        const b = allBranches[i]
        if (isAdmin()) {
          permittedBranches.push(b)
        } else if (hasPermission(`branch_permission_${b.id}`)) {
          permittedBranches.push(b)
        }
      }

      if (!localStorage.getItem('branch') && permittedBranches.length > 0) {
        setBranch('')
        localStorage.removeItem('branch')
      }

      setBranches(permittedBranches)
      setLoadingBranches(false)
    }

    const onFailure = () => {
      setBranches([])
      setLoadingBranches(false)
    }

    dispatch(getBranches({}, onSuccess, onFailure))
  }

  const handleBranch = (branch: any) => {
    setBranch(branch)

    if (branch) {
      localStorage.setItem('branch', branch)
    } else {
      localStorage.removeItem('branch')
    }
    window.location.reload()
  }

  useEffect(() => {
    loadBranches()

    return () => {
      setBranches([])
      setLoadingBranches(false)
      setBranch('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    updateDOM(config)
  }, [config])

  return (
    <div
      className='
        menu
        menu-rounded
        menu-column
        menu-lg-row
        my-5
        my-lg-0
        align-items-stretch
        fw-semibold
        px-2 px-lg-0
    '
      id='kt_app_header_menu'
      data-kt-menu='true'
    >
      <div className='d-flex align-items-center justify-content-center justify-content-lg-start flex-lg-fill flex-wrap'>
        {
          <Select
            className={clsx('w-150px w-xxl-150px', {
              'd-none': !loadingBranches && !branches.length,
            })}
            value={branch}
            onChange={handleBranch}
            options={branches.map((item) => ({value: item.id, label: item.name}))}
            isLoading={loadingBranches}
          />
        }
        {activeSession && activeSession?.db_postfix && (
          <div className='badge ms-1 p-4 fs-7' style={{backgroundColor: 'var(--bs-teal)'}}>
            Session: {activeSession.name}
          </div>
        )}

        {hasPermission('user_manager_settings') && generalSettings.on_boarding_enabled === 1 && (
          <div className='ms-xl-auto'>
            <ClientOnboardPage />
          </div>
        )}

        {/* Support Tickets */}
        {hasPermission('tickets_manager') && (
          <div className='app-navbar-item ms-1 ms-md-4'>
            <a
              href='/institute/support-tickets'
              className={clsx(
                'd-flex align-items-center justify-content-center px-3 py-2 rounded w-auto',
                'text-primary',
                'text-hover-primary'
              )}
              style={{whiteSpace: 'nowrap'}}
            >
              <i className='fa fa-headset me-2' style={{fontSize: '15px'}} />
              {intl.formatMessage({id: 'MENU.SUPPORT_TICKETSPAGE'})}
            </a>
          </div>
        )}
      </div>

      {/* <MenuInner /> */}
    </div>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.header?.default?.fixed?.desktop) {
    document.body.setAttribute('data-kt-app-header-fixed', 'true')
  }

  if (config.app?.header?.default?.fixed?.mobile) {
    document.body.setAttribute('data-kt-app-header-fixed-mobile', 'true')
  }

  if (config.app?.header?.default?.stacked) {
    document.body.setAttribute('data-kt-app-header-stacked', 'true')
  }

  const appHeaderDefaultStickyEnabled = config.app?.header?.default?.sticky?.enabled
  let appHeaderDefaultStickyAttributes: {[attrName: string]: string} = {}
  if (appHeaderDefaultStickyEnabled) {
    appHeaderDefaultStickyAttributes = config.app?.header?.default?.sticky?.attributes as {
      [attrName: string]: string
    }
  }

  const appHeaderDefaultMinimizeEnabled = config.app?.header?.default?.minimize?.enabled
  let appHeaderDefaultMinimizeAttributes: {[attrName: string]: string} = {}
  if (appHeaderDefaultMinimizeEnabled) {
    appHeaderDefaultMinimizeAttributes = config.app?.header?.default?.minimize?.attributes as {
      [attrName: string]: string
    }
  }

  setTimeout(() => {
    const headerElement = document.getElementById('kt_app_header')
    // header
    if (headerElement) {
      if (appHeaderDefaultStickyEnabled) {
        for (const key in appHeaderDefaultStickyAttributes) {
          if (appHeaderDefaultStickyAttributes.hasOwnProperty(key)) {
            headerElement.setAttribute(key, appHeaderDefaultStickyAttributes[key])
          }
        }
      }

      if (appHeaderDefaultMinimizeEnabled) {
        for (const key in appHeaderDefaultMinimizeAttributes) {
          if (appHeaderDefaultMinimizeAttributes.hasOwnProperty(key)) {
            headerElement.setAttribute(key, appHeaderDefaultMinimizeAttributes[key])
          }
        }
      }
    }
  }, 0)
}

export {Header}
